module.exports = __webpack_public_path__ + "static/media/photo-16.6d171e53.png";